<script lang="ts" setup>
interface Props {
  size?: 'small' | 'big'
}

withDefaults(defineProps<Props>(), { size: 'big' })
</script>

<template>
  <span
    class="absolute inset-0 z-20 flex items-center justify-center text-white opacity-0 duration-300 after:absolute after:inset-0 after:z-10 after:bg-primary after:opacity-60 hover:opacity-100"
  >
    <span
      class="z-20"
      :class="{
        'text-3xl': size === 'big',
        'text-xl': size === 'small',
      }"
    >
      <Icon mode="svg" name="simple-line-icons:magnifier-add" />
    </span>
  </span>
</template>
